import React, { Component } from 'react';
import { Modal, Button, Input, Divider, Spin } from 'antd';
import ReactMarkdown from 'react-markdown';
import { saveAIResult } from "@/request/api";

import ReactDOMServer from 'react-dom/server';
import { requestErrorLog } from "../../../common/util";
// import { marked } from 'marked';
const { TextArea } = Input;

class DeepSeekModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            AIRequestType: 3,//0:请求中；1：请求成功；2：请求失败;3：已有结果不用请求
            controller: null,
        }
    }

    componentDidMount() {
        const { deepSeekModalPatientPart, deepSeekModalType } = this.props
        if (deepSeekModalType === 0) {
            if (deepSeekModalPatientPart.AI_INTERPRETATION) {
                this.setState({
                    AIRequestType: 3
                })
            } else {
                this.setState({
                    AIRequestType: 0
                }, () => {
                    //请求ai
                    this.callDeepSeekAPI(deepSeekModalPatientPart.CONCLUSIONS + '。请根据上述报告结论给出报告解读', 0)
                })
            }
        } else {
            if (deepSeekModalPatientPart.AI_EXAM_SUGGEST) {
                this.setState({
                    AIRequestType: 3
                })
            } else {
                this.setState({
                    AIRequestType: 0
                }, () => {
                    //请求ai
                    this.callDeepSeekAPI(deepSeekModalPatientPart.CONCLUSIONS + '。我是基层医疗机构医生，请帮我解读上述报告结论，给予基层医疗机构诊疗建议，并写明参考来源', 1)
                })
            }
        }


    }

    callDeepSeekAPI = async (inputData) => {
        this.setState({
            controller: new AbortController()
        }, async () => {
            const signal = this.state.controller.signal;
            const url = 'https://api.deepseek.com/v1/chat/completions';
            const apiKey = 'sk-ba74e191f5cb445d9a1592664466b05a'; // 注意：不要在前端硬编码API Key！

            const data = {
                model: "deepseek-chat",
                messages: [
                    { role: "system", content: "You are a helpful assistant." },
                    { role: "user", content: inputData }
                ],
                stream: true,
                temperature: 1.0
            };
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}` // 注意：不要在前端硬编码API Key！
                    },
                    body: JSON.stringify(data),
                    signal
                });
                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let contentAnswer = '';
                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;

                    const chunk = decoder.decode(value);
                    console.log(chunk)
                    this.setState({
                        AIRequestType: 1
                    }, () => {
                        chunk.split('\n\n').forEach(event => {
                            if (event.startsWith('data:')) {
                                if (event === 'data: [DONE]') {
                                    //解读完成存入数据库
                                    this.saveDataToServe(contentAnswer)
                                    return;
                                }
                                const data = JSON.parse(event.replace('data:', ''));
                                if (data.choices.length !== 0) {
                                    contentAnswer += data.choices[0].delta.content;
                                    const html = ReactDOMServer.renderToString(<ReactMarkdown>{contentAnswer}</ReactMarkdown>);
                                    document.getElementById('responseWrite').innerHTML = html;
                                }

                            }
                        });
                    })
                }
                if (!response.ok) {
                    this.setState({
                        AIRequestType: 2
                    })
                    throw new Error(`HTTP error! status: ${response.status}`);

                }
            } catch (error) {
                this.setState({
                    AIRequestType: 2
                })
                console.error('Error:', error);
            }
        })
    }

    saveDataToServe = (contentAnswer) => {
        //后端存入字段
        const { deepSeekModalPatientPart, deepSeekModalType } = this.props
        if (deepSeekModalType === 0) {//解读
            let param = {
                Type: "SaveInterpretationResult",
                EXAM_UID: deepSeekModalPatientPart.EXAM_UID,
                AI_INTERPRETATION: contentAnswer,
            }
            saveAIResult(param).then((res) => {
                if (res && res.Status === 1) {
                    if (res.Result === -1) {
                        console.log('ai解读结果存入失败')
                    } else {
                        console.log('ai解读结果存入成功')
                    }
                } else {
                    requestErrorLog("", "ai解读录入失败", 0, true);
                }
            })

        } else {//建议
            let param = {
                Type: "SaveSuggestResult",
                EXAM_UID: deepSeekModalPatientPart.EXAM_UID,
                AI_EXAM_SUGGEST: contentAnswer,
            }
            saveAIResult(param).then((res) => {
                if (res && res.Status === 1) {
                    if (res.Result === -1) {
                        console.log('ai建议结果存入失败')
                    } else {
                        console.log('ai建议结果存入成功')
                    }
                } else {
                    requestErrorLog("", "ai建议录入失败", 0, true);
                }
            })
        }
    }
    handleCancel = () => { // 关闭弹框
        if (this.state.controller) {
            this.state.controller.abort();
        }
        this.setState({
            controller: null,

        }, () => {
            this.props.onRef(false);
        })
    }

    tryAgain = () => {
        this.setState({
            AIRequestType: 0
        }, () => {
            const { deepSeekModalPatientPart, deepSeekModalType } = this.props
            if (deepSeekModalType === 0) {
                this.callDeepSeekAPI(deepSeekModalPatientPart.CONCLUSIONS + '。请根据上述报告结论给出报告解读', 0)
            } else {
                this.callDeepSeekAPI(deepSeekModalPatientPart.CONCLUSIONS + '。我是基层医疗机构医生，请帮我解读上述报告结论，给予基层医疗机构诊疗建议，并写明参考来源', 0)
            }
        })
    }
    showAOrB = () => {
        //AI_EXAM_SUGGEST AI诊疗建议
        //AI_INTERPRETATION报告解读
        const { deepSeekModalType, deepSeekModalPatientPart } = this.props
        if (deepSeekModalType === 0) {
            if (deepSeekModalPatientPart.AI_INTERPRETATION) {
                // return <div style={{ padding: '4px 11px' }}>{deepSeekModalPatientPart.AI_INTERPRETATION}</div>
                return <ReactMarkdown>{deepSeekModalPatientPart.AI_INTERPRETATION}</ReactMarkdown>
            } else {
                if (this.state.AIRequestType === 0) {
                    return <Spin
                        tip='报告解读中，请稍后'
                        size="large"
                        className='AISpin'
                    />
                } else if (this.state.AIRequestType === 1) {//AI生成完毕
                    return <div id='responseWrite'></div>
                } else if (this.state.AIRequestType === 2) {//AI生成失败
                    return <div className='loswerPart'>
                        <div className='loswerCicle'>+</div>
                        <p>报告解读失败，请重试</p>
                        <Button className='tryAgain' onClick={this.tryAgain}>重试</Button>
                    </div>
                }
            }

        } else {
            if (deepSeekModalPatientPart.AI_EXAM_SUGGEST) {
                return <ReactMarkdown>{deepSeekModalPatientPart.AI_EXAM_SUGGEST}</ReactMarkdown>
            } else {
                if (this.state.AIRequestType === 0) {
                    return <Spin
                        tip='诊疗建议回复中，请稍后'
                        size="large"
                        className='AISpin'
                    />
                } else if (this.state.AIRequestType === 1) {//AI生成完毕
                    return <div id='responseWrite'></div>
                } else if (this.state.AIRequestType === 2) {//AI生成失败
                    return <div className='loswerPart'>
                        <div className='loswerCicle'>+</div>
                        <p>建议回复超时，请重试</p>
                        <Button className='tryAgain' onClick={this.tryAgain}>重试</Button>
                    </div>
                }
            }
        }

    }

    render() {
        const { visible, deepSeekModalPatientPart, deepSeekModalType } = this.props

        return (
            <>
                <Modal
                    visible={visible}
                    width="1020px"
                    className="addPatientWrap"
                    title={
                        <div className="patient_title">
                            <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                            <span>{deepSeekModalType === 0 ? '报告解读' : '诊疗建议'}</span>
                        </div>
                    }
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <div className='AIPart1'>
                        <p>患者姓名：{deepSeekModalPatientPart.NAME}</p>
                        <p>性别：{deepSeekModalPatientPart.SEX_NAME}</p>
                        <p>年龄：{deepSeekModalPatientPart.AgeDisPlay ? deepSeekModalPatientPart.AgeDisPlay : (deepSeekModalPatientPart.EXAM_AGE + deepSeekModalPatientPart.AGE_UNIT)}</p>
                        <p>联系电话：{deepSeekModalPatientPart.CONTACT_TEL}</p>
                        <p>身份证号：{deepSeekModalPatientPart.ID_NUMBER}</p>
                    </div>
                    <Divider></Divider>
                    <p className='AIPart2P'>报告结论：</p>
                    <TextArea
                        className='AIPart2TextArea'
                        value={deepSeekModalPatientPart.CONCLUSIONS}
                        autoSize={{ minRows: 5, maxRows: 5 }}
                        disabled
                        style={{
                            height: 125,
                            resize: 'none',
                        }}
                    />
                    <p className='AIPart2P' style={{ marginTop: '20px' }}>{deepSeekModalType === 0 ? '报告解读：' : '诊疗建议：'}</p>
                    <div className='AIAnwer' id='AIAnwer'>
                        {this.showAOrB()}
                    </div>
                    <div className='AIfooter'>
                        <p>&nbsp;</p>
                        <p>
                            <Button className='AIButton' onClick={this.handleCancel}>关闭</Button>
                        </p>
                        <p style={{ textAlign: 'right', marginRight: '20px' }}>注：以上内容由DeepSeek AI大模型提供，仅供参考</p>
                    </div>

                </Modal>
            </>
        )
    }
}

export default DeepSeekModal;